import { useRecoilState, useRecoilValue } from 'recoil';
import { useAuthContext } from '../../../common/contexts/useAuthContext';
import { currentReactVersionState } from '../atoms/currentReactVersionState';
import { navigationPropsState } from '../atoms/navigationPropsState';
import { NavigationProps } from '../../types/navigation';
import { trackEvent } from '../../services/server/analytics/trackEvent';


export const useSetNavigationProps = () => {

  const { currentUser } = useAuthContext();
  const currentReactVersion = useRecoilValue(currentReactVersionState);

  const [navigationProps, setNavigationProps] = useRecoilState(navigationPropsState);

  const updateNavigationProps = (
    newNavigationProps: Partial<NavigationProps>,
    isNavigationEvent?: boolean, // navigation events will reset some properties (unless they are part of this update)
  ) => {

    const updatedNavigationProps = {
      ...navigationProps,
      ...newNavigationProps,
    };

    if (isNavigationEvent) {
      updatedNavigationProps.selectedPlayerIdForNewClause = newNavigationProps.selectedPlayerIdForNewClause;
      updatedNavigationProps.reportHasUnsavedChanges = newNavigationProps.reportHasUnsavedChanges;
      updatedNavigationProps.clauseHasUnsavedChanges = newNavigationProps.clauseHasUnsavedChanges;
      updatedNavigationProps.alertHasUnsavedChanges = newNavigationProps.alertHasUnsavedChanges;
      updatedNavigationProps.roleConfigHasUnsavedChanges = newNavigationProps.roleConfigHasUnsavedChanges;
      updatedNavigationProps.formationConfigHasUnsavedChanges = newNavigationProps.formationConfigHasUnsavedChanges;
    }

    if (newNavigationProps.activeNavigationTab && newNavigationProps.activeNavigationTab !== navigationProps.activeNavigationTab) {
      trackEvent('TabClicked', { tab: newNavigationProps.activeNavigationTab }, currentUser, 'user', currentReactVersion);
    }

    setNavigationProps(updatedNavigationProps);
  };

  return updateNavigationProps;
};
